import { useState, useCallback } from 'react';
import config from '@/config';

interface FetchResponse<T> {
  data: T | null;
  error: Error | null;
  isLoading: boolean;
}

const useFetch = <T>(initialUrl: string, initialOptions: RequestInit = {}) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchData = useCallback(async (url: string = initialUrl, options: RequestInit = initialOptions) => {
    setIsLoading(true);
    setError(null);
    setData(null);

    try {
      const fullUrl = `${config.baseApi}${url}`;
      console.log('fetching', fullUrl);
      const response = await fetch(fullUrl, options);

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const result = await response.json();
      setData(result);
    } catch (err: any) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [initialUrl, initialOptions]);

  return { data, error, isLoading, fetchData };
};

export default useFetch;